"use client"

import React from "react"
import Image from "next/image"
import { Link, type Locale } from "@/i18n/routing"
import { AspectRatio } from "@radix-ui/react-aspect-ratio"

import { cn } from "@/lib/utils"

interface NameGeneratorCardProps extends React.HTMLAttributes<HTMLDivElement> {
  index: number
  locale: Locale
  category: string
  slugAsParams: string
  title: string
  subTitle: string
  image: string
  translatedSubject: string
}

function NameGeneratorCardComponent(props: NameGeneratorCardProps) {
  const {
    index,
    className,
    category,
    slugAsParams,
    title,
    subTitle,
    image,
    translatedSubject,
  } = props

  const hrefSegments = slugAsParams.split("/")

  return (
    <Link
      // prefetch={false}
      // aria-label={title}
      href={{
        pathname: "/[category]/[...slug]",
        params: { category: category, slug: hrefSegments },
      }}
      scroll={true}
    >
      <div className={cn("relative flex h-full flex-col space-y-3", className)}>
        <AspectRatio
          ratio={1 / 1}
          className="w-full overflow-hidden rounded-lg "
        >
          <Image
            src={image}
            alt={title}
            // height={560}
            // width={560}
            fill
            sizes="(max-width: 640px) 90vw, 320px" // Die 320 sind in next.config.js definiert
            className="bg-gray-200 object-cover object-center group-hover:opacity-75"
            // placeholder="blur"
            // blurDataURL={image}
            priority={index < 1 ? true : false}
          />
        </AspectRatio>
        <div className="flex-1 space-y-1 text-sm">
          <h3 className="absolute right-3 top-2 bg-black p-2 font-medium leading-none text-white">
            {translatedSubject}
          </h3>
          {/* <p className="text-xs text-muted-foreground">{subTitle}</p> */}
        </div>
      </div>
    </Link>
  )
}

// Now wrap the component function with React.memo
const NameGeneratorCard = React.memo(NameGeneratorCardComponent)

export default NameGeneratorCard
